module.exports = __webpack_public_path__ + "a99ee8f691fa06a410cd219f14fd0228.png";